import { ethereum } from '@0xtorch/core'
import { linea } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createLineaChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createLineaChainCustom({
    client: createClient({
      chain: linea,
      httpRpcs: lineaHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'LineaScan',
      baseUrl: 'https://lineascan.build',
      chainId: 59_144,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateLineaChainParameters = {
  client: Client
  explorer: Explorer
}

export const createLineaChainCustom = ({
  client,
  explorer,
}: CreateLineaChainParameters): Chain => ({
  id: 59_144,
  network: 'linea',
  name: 'Linea',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f',
  ]),
  explorer,
  client,
  blockTime: 6000,
  coingeckoId: 'linea',
  defillamaId: 'linea',
})

export const lineaHttpRpcs: HttpRpc[] = [
  // Endpoint is not working
  // {
  //   url: 'https://linea.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1024n,
  // },
  {
    url: 'https://1rpc.io/linea',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://linea.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://linea.decubate.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://rpc.linea.build',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 40_000n,
  },
  {
    url: 'https://linea.rpc.thirdweb.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://linea-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
]

export const lineaWebsocketRpcUrls: readonly string[] = []
